// extracted by mini-css-extract-plugin
export default {"button":"delete_button__9cB4Z","button--danger":"delete_button--danger__UBO8b","button__icon":"delete_button__icon__gvP8B","rotate":"delete_rotate__cIisp"};